import React, { Component } from "react";
import SEO from "react-seo-component";
import Footer from "../../components/Footer/footer";
import NavbarPage from "../../components/Navbar/Navbar_Page";
import Section from "../landing/section";
class Index1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { id: 1, idnm: "home", navheading: "Home" },
        { id: 2, idnm: "services", navheading: "Services" },
        { id: 3, idnm: "features", navheading: "Features" },
        { id: 4, idnm: "clients", navheading: "Clients" },
        { id: 6, idnm: "pricing", navheading: "Plans" },
      ],
      pos: document.documentElement.scrollTop,
      imglight: false,
      navClass: "",
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky", imglight: false });
    } else {
      this.setState({ navClass: "", imglight: false });
    }
  };
  render() {
    return (
      <React.Fragment>
        {/* Importing Navbar */}
        <NavbarPage
          navItems={this.state.navItems}
          navClass={this.state.navClass}
          imglight={this.state.imglight}
        />

        {/* Importing section */}
        <Section
          seo={
            <SEO
              title={
                "Truck and Driver Hire - Reliable Transportation Services in South Africa "
              }
              titleTemplate={"QikTruck"}
              titleSeparator={`-`}
              description={
                "Looking for affordable truck and driver hire in South Africa? QikTruck offers reliable services for moving, deliveries, and more. Our 1.5 ton bakkies have automatic transmission and air con. Book online today!"
              }
              image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
              pathname={"https://qiktruck.co.za/bakkie-hire"}
              twitterUsername={"qiktrucksa"}
            />
          }
          heading={
            <h2 className="main-headline">On-demand truck and driver hire</h2>
          }
        />

        {/* Importing Footer */}
        <Footer />
      </React.Fragment>
    );
  }
}

export default Index1;
